// extracted by mini-css-extract-plugin
export var box = "_24-2";
export var checkboxControl = "_24-0";
export var checkboxRow = "_24-a";
export var checked = "_24-3";
export var descriptionSpacer = "_24-c";
export var disabled = "_24-4";
export var icon = "_24-8";
export var input = "_24-1";
export var labelSpacer = "_24-b";
export var large = "_24-7";
export var medium = "_24-6";
export var small = "_24-5";
export var text = "_24-9";